export const Types = {
  IS_AUTH: "auth/IS_AUTH",
  LOGOUT: "auth/LOGOUT"
};

const INITIAL_STATE = {
  login: null
};

export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.IS_AUTH:
      return { ...state, login: true };
    case Types.LOGOUT:
      window.location.href = `/${localStorage.getItem("@ecorban-app:tenant")}`;
      localStorage.removeItem("@ecorban-app:token");
      return { ...state, login: false };
    default:
      return state;
  }
}

export const Creators = {
  isAuth: () => ({
    type: Types.IS_AUTH
  }),
  logout: () => ({
    type: Types.LOGOUT
  })
};


// WEBPACK FOOTER //
// ./src/store/ducks/auth.js